"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = NavHeadshot;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gatsbyPluginImage = require("gatsby-plugin-image");
var _logo = _interopRequireDefault(require("../logos/logo"));
var _utils = require("../../utils/utils");
// Packages

// Components

// Utils

// Styles
const {
  below
} = (0, _utils.getMediaQueries)();
const LogoWrapper = _styledComponents.default.div.withConfig({
  displayName: "headshot__LogoWrapper",
  componentId: "sc-1r12ot3-0"
})(["display:flex;align-items:center;.headshot{border-radius:50%;flex-shrink:0;width:48px;height:48px;", "}&.logo-headshot{svg{width:34px;width:fit-content;height:40px;", "}}&.fullABMGLogo{height:45px;margin-right:40px;transition:0.3s ease-in-out;", ";", ";}height:64px;margin-right:40px;transition:0.3s ease-in-out;", ";"], below.tablet`
    width:40px;
    height:40px;
    `, below.tablet`
    width:29px;
    width: fit-content;
    height:34px;
    `, below.tablet`
      height:35px;
      margin-right: 0;
    `, below.mobile`
      height:25px;
    `, below.tablet`
    max-height:40px;
    margin-right: 0;
  `);
const Divider = _styledComponents.default.div.withConfig({
  displayName: "headshot__Divider",
  componentId: "sc-1r12ot3-1"
})(["flex-shrink:0;margin:0 16px;height:48px;width:1px;background:linear-gradient(#ffffff,#e2e8f0,#ffffff);", ""], below.tablet`
  height:40px;
  margin:0 12px;
  `);
const DefaultHeadshot = _styledComponents.default.div.withConfig({
  displayName: "headshot__DefaultHeadshot",
  componentId: "sc-1r12ot3-2"
})(["border-radius:50%;overflow:hidden;width:48px;height:48px;border:2px solid hsla(204,45%,98%,0.35);display:block;background-color:#264765;display:flex;align-items:center;justify-content:center;color:white;font-weight:700;font-size:20px;line-height:20px;", ""], below.tablet`
    width:40px;
    height:40px;
    `);

// Main Component
function NavHeadshot({
  professional,
  logo
}) {
  return /*#__PURE__*/_react.default.createElement(LogoWrapper, {
    className: "logo-headshot"
  }, logo || /*#__PURE__*/_react.default.createElement(_logo.default, {
    logo: "abmg-nav-icon-default"
  }), /*#__PURE__*/_react.default.createElement(Divider, null), professional !== null && professional !== void 0 && professional.headshot && (professional === null || professional === void 0 ? void 0 : professional.headshot.title) !== "profile-default" ? /*#__PURE__*/_react.default.createElement(_gatsbyPluginImage.GatsbyImage, {
    className: "headshot",
    image: professional === null || professional === void 0 ? void 0 : professional.headshot.gatsbyImageData,
    alt: (professional === null || professional === void 0 ? void 0 : professional.fullName) || (professional === null || professional === void 0 ? void 0 : professional.name)
  }) : /*#__PURE__*/_react.default.createElement(DefaultHeadshot, null, `${(professional === null || professional === void 0 ? void 0 : professional.firstName) && (professional === null || professional === void 0 ? void 0 : professional.firstName.charAt())}${(professional === null || professional === void 0 ? void 0 : professional.lastName) && (professional === null || professional === void 0 ? void 0 : professional.lastName.charAt())}`));
}

// Prop Types
NavHeadshot.propTypes = {
  professional: _propTypes.default.shape({
    headshot: _propTypes.default.shape(),
    fullName: _propTypes.default.string,
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string,
    name: _propTypes.default.string
  }),
  /**
   * Logo component can be used or default logo will be used
   */
  logo: _propTypes.default.element
};
NavHeadshot.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "NavHeadshot",
  "props": {
    "professional": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "headshot": {
            "name": "shape",
            "value": "PropTypes.shape()",
            "computed": true,
            "required": false
          },
          "fullName": {
            "name": "string",
            "required": false
          },
          "firstName": {
            "name": "string",
            "required": false
          },
          "lastName": {
            "name": "string",
            "required": false
          },
          "name": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "logo": {
      "description": "Logo component can be used or default logo will be used",
      "type": {
        "name": "element"
      },
      "required": false
    }
  }
};